var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 7.5,
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    strokeWidth: 0.577,
    transform: "translate(1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.9e49c7364c25fbca377bf2b613b24a5b.svg";
export { ForwardRef as ReactComponent };